<template>
	<div class="blockPanel">
		<slot name="header"></slot>

		<div class="module-main" v-loading="loading" :class="paddingClass">
			<component
				:is="componentType"
				v-bind="panelData"
				v-on="$listeners"
				v-if="permission"
			></component>
			<div v-else>
				<client-no-access :name="title"></client-no-access>
			</div>
		</div>
	</div>
</template>
<script>
import clientNoAccess from '@/components/client/noAccess/noAccess.vue';
import mixinsWatch from '@/client/mixinsWatch/mixinsWatch';
export default {
	mixins: [mixinsWatch],
	name: 'blockPanel',
	props: ['componentType', 'query', 'permissionName', 'title', 'defaultPadding'],
	data() {
		return {
			loading: false,
			panelData: {},
		};
	},
	computed: {
		paddingClass: self => {
			return {
				modulePadding: self.defaultPadding,
			};
		},
		permission() {
			if (typeof this.permissionName == 'string') {
				return this.getFlagPermission(this.permissionName);
			} else if (typeof this.permissionName == 'function') {
				return this.permissionName();
			} else if (this.permissionName === null || this.permissionName == undefined) {
				return true;
			} else {
				return this.permissionName;
			}
		},
	},
	methods: {
		async requestData() {
			this.loading = true;
			try {
				if (typeof this.query == 'object') {
					this.panelData = this.query;
				} else {
					this.panelData = await this.query();
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
			}
		},
	},
	components: {
		clientNoAccess,
	},
};
</script>
<style lang="scss" scoped>
.module-main {
	min-height: 80px;
	box-sizing: border-box;
	height: auto;
}

.modulePadding {
	padding-left: 22px;
}
</style>
